// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lQdjH","colMin":"styles_colMin__2hyw1"};